import api from "../../api";

const state = {
  status: "",
  list: [],
  listDealsTotal: [],
  dealsDB: {
    1: []
  },
  filterBySeller: null,
  filterByProduct: null
};

const getters = {
  isLoading: (state) => state.status === "loading",
  dealsByPhase: (state) => (phaseId) => {
    const deals = state.deals[phaseId];
    let d = deals !== undefined ? deals : [];

    if (state.filterBySeller) {
      d = d.filter(
        (f) =>
          f.CreatedBy === state.filterBySeller ||
          f.ResponsibleID === state.filterBySeller
      );
    }
    return d;
  }
};

const actions = {
  create: ({ commit }, new_deal) => {
    return new Promise((resolve, reject) => {
      commit("loading");
      api
        .post("/api/deals/add", new_deal)
        .then((resp) => {
          commit("success");
          commit("pushItem", resp.data);
          commit("PUSH_DEAL_BY_PHASE", {
            phaseId: resp.data.PhaseID,
            deal: resp.data
          });
          resolve(resp);
        })
        .catch((err) => {
          commit("error");
          reject(err);
        });
    });
  },
  fetchDeals: ({ commit, rootState }, { phaseId }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      const { UserID, CompanySelected } = rootState.user.user;

      api
        .get("/api/deals", {
          timeout: 30000 * 3,
          params: {
            userID: UserID,
            phaseID: parseInt(phaseId),
            companyID: CompanySelected
          }
        })
        .then((response) => {
          commit("success");
          commit("SET_DEALS_BY_PHASE", {
            phaseId: parseInt(phaseId),
            deals: response.data.Items ?? []
          });
          resolve(response);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  },
  getAll: ({ commit, rootState }) => {
    return new Promise((resolve, reject) => {
      commit("loading");
      api
        .get("/api/deals/all", {
          params: {
            companId: rootState.user.user.CompanySelected
          }
        })
        .then((resp) => {
          commit("success");
          commit("list", resp.data.Items);
          resolve(resp);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  },
  getDealsTotal: ({ commit, rootState }) => {
    return new Promise((resolve, reject) => {
      commit("loading");
      api
        .get("/api/deals/GetDealSummary", {
          params: {
            CompanyCode: rootState.user.user.CompanySelected,
            UserID: rootState.user.user.UserID
          }
        })
        .then((resp) => {
          commit("success");
          commit("listDealsTotal", resp.data);
          resolve(resp);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  }
};

const mutations = {
  loading: (state) => (state.status = "loading"),
  success: (state) => (state.status = "success"),
  error: (state) => (state.status = "error"),
  list: (state, list) => {
    state.list = list;
  },
  listDealsTotal: (state, list) => {
    state.listDealsTotal = list;
  },
  pushItem: (state, item) => {
    state.list.push(item);
  },
  INIT_DEALS_DB: (state, phases) => {
    phases.forEach((phase) => {
      state.dealsDB[parseInt(phase.value)] = phase.deals;
    });
  },
  UPDATE_DEALS_DB: (state, { phaseId, deals }) => {
    if (state.dealsDB[phaseId] === undefined) {
      state.dealsDB[phaseId] = [];
    }

    state.dealsDB[phaseId] = deals;
  },
  UNSHIFT_DEAL_BY_PHASE: (state, { phaseId, deal }) => {
    if (state.dealsDB[phaseId] === undefined) {
      state.dealsDB[phaseId] = [];
    }

    state.dealsDB[phaseId].unshift(deal);
  },
  MOVE_DEAL: (state, { from, to, deal }) => {
    if (state.dealsDB[from] === undefined) {
      state.dealsDB[from] = [];
    }
    const phaseFrom = state.dealsDB[from];

    if (state.dealsDB[to] === undefined) {
      state.dealsDB[to] = [];
    }
    const phaseTo = state.dealsDB[to];

    const fromIndex = phaseFrom.findIndex((f) => f.Id === deal.Id);
    phaseFrom.splice(fromIndex, 1);

    if (phaseTo === null) {
      state.dealsDB[to] = [deal];
    } else {
      phaseTo.unshift(deal);
    }
  },
  DELETE_DEAL: (state, { phaseId, deal }) => {
    const index = state.dealsDB[phaseId].findIndex((f) => f.Id === deal.Id);
    state.dealsDB[phaseId].splice(index, 1);
  },
  UPDATE_DEAL: (state, deal) => {
    const deals = state.dealsDB[deal.PhaseID];
    if (deals !== null && deals) {
      const index = deals.findIndex((f) => f.Id === deal.Id);
      const oldDeal = deals.find((f) => f.Id === deal.Id);
      const update = { ...oldDeal, ...deal };
      deals.splice(index, 1, update);
    }
  },
  SET_FILTER_BY_SELLER: (state, payload) => {
    state.filterBySeller = payload;
  },
  SET_FILTER_BY_PRODUCT: (state, payload) => {
    state.filterByProduct = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
